var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115 45",
    style: {
      enableBackground: "new 0 0 115 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2ACDC1;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;\r\n\tstroke-dasharray: 450;\r\n  stroke-dashoffset: -450;\r\n  \r\n  }\r\n\t.st1{fill:none;stroke:#2ACDC1;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10; \r\n  stroke-dasharray: 450;\r\n  stroke-dashoffset: -450;\r\n  \r\n  }\r\n  @keyframes draw {\r\n\t  0%{\r\n\t\t \r\n  stroke-dashoffset: -450;\r\n\t  }\r\n  10% {\r\n    stroke-dashoffset: 220;\r\n  }\r\n  100%{\r\nstroke-dashoffset: 220;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0 animate-arrow-svg",
    d: "M108.5,35.4c-9,8.8-24.1,9.4-35,3.5c-4.5-2.5-10-7.6-8.2-13.4c0.8-2.6,4.6-7,7.5-3.8 c3.6,4.1-3.8,11.4-6.2,13.4c-7,5.7-16.6,8-25.5,6.5C20.8,38.2,11.1,18.5,3.5,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 animate-arrow-svg",
    d: "M110,43.3c-1-4.3,1.6-7.7,1.5-11.9c-2.9,1.4-8.9,4-12.2,3.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDraw);
export default __webpack_public_path__ + "static/media/arrow_draw.115a0ad1.svg";
export { ForwardRef as ReactComponent };